module.exports = __webpack_public_path__ + "static/media/patjarpodcast.53c55299.jpg";